import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { ChipContainer, RestyledScrollArea } from '@components/Feed/shared';
import {
  ScrollViewport,
  StyledScrollbar,
  StyledThumb,
} from '@components/main-components/containers/RadixScroll';
import { Chip } from '@components/main-components/elements/chips/Chip';
import { CollectorActivityFeedTypeFilterOption } from '@graphql/reactQuery';
import { multiSelectOptionIsSelected, selectMultiSelectOption } from '@utils/helpers';

type FeedType = {
  type: CollectorActivityFeedTypeFilterOption;
  label: string;
  icon?: React.ReactNode;
}[];

const FEED_TYPES = (): FeedType => [
  {
    type: CollectorActivityFeedTypeFilterOption.All,
    label: 'All',
  },
  { type: CollectorActivityFeedTypeFilterOption.Posts, label: 'Posts' },
  {
    type: CollectorActivityFeedTypeFilterOption.Collections,
    label: 'Collected',
  },
  {
    type: CollectorActivityFeedTypeFilterOption.Playlists,
    label: 'Playlists',
  },
  {
    type: CollectorActivityFeedTypeFilterOption.Likes,
    label: 'Likes',
  },
];

export const FeedHeader = ({
  filter,
  setFilter,
}: {
  filter: CollectorActivityFeedTypeFilterOption[];
  setFilter: (selection: CollectorActivityFeedTypeFilterOption[]) => void;
}) => {
  return (
    <Filter>
      <RestyledScrollArea>
        <ScrollViewport>
          <FilterContainer>
            {FEED_TYPES().map(({ type, label }) => (
              <ChipContainer key={type}>
                <Chip
                  text={label}
                  isSelected={multiSelectOptionIsSelected({
                    prev: filter || [],
                    currentSelected: type,
                    all: Object.values(CollectorActivityFeedTypeFilterOption),
                    allKey: CollectorActivityFeedTypeFilterOption.All,
                  })}
                  onClick={() => {
                    setFilter(
                      selectMultiSelectOption({
                        prev: filter || [],
                        currentSelected: type,
                        all: Object.values(CollectorActivityFeedTypeFilterOption),
                        allKey: CollectorActivityFeedTypeFilterOption.All,
                      }),
                    );
                  }}
                />
              </ChipContainer>
            ))}
          </FilterContainer>
        </ScrollViewport>
        <StyledScrollbar orientation="horizontal" hiddenOnMobile>
          <StyledThumb />
        </StyledScrollbar>
      </RestyledScrollArea>
    </Filter>
  );
};

const Filter = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginLeft: 24,
  marginTop: 12,

  h3: {
    kicker: 'S',
    fontStyle: 'regular',
    textTransform: 'uppercase',
  },

  '@tablet': {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },

  '@laptop': {
    marginLeft: 0,
  },
});

const FilterContainer = styled('div', {
  display: 'flex',
  width: '100%',
});
